import { Card, Col, Container, Row } from "react-bootstrap";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import imgTugas from "../assets/img/clipboard.png";
import imgRekap from "../assets/img/business-report.png"
import imgMc from "../assets/img/mc.png"
import imgFlexible from "../assets/img/flexible.png"
import imgApp from "../assets/img/app-menu.png"
import imgMoney from "../assets/img/money.png"
import imgShop from "../assets/img/online-shopping.png"
import imgToken from "../assets/img/token.png"

import ScrollAnimation from "react-animate-on-scroll";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

const settingsFirst = {
    dots: false,
    autoplay: false,
    swipe: false,
    arrows: false,
}

const settings = {
    dots: true,
    autoplay: true,
    infinite: false,
    swipe: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
}

const Service = () => {
    let firstRef = useRef<any>(null)
    const [number, setNumber] = useState(0)

    useEffect(() => {
        if(number === 0) {
            firstRef.current.slickGoTo(0)
        }else{
            firstRef.current.slickGoTo(1)
        }
    }, [number])

    return(
        <Container className="service pt-5 pb-5">
            <Row>
                <Col sm={12} md={3} lg={3} className="mb-3">
                    <ScrollAnimation animateIn='bounce' animateOnce={true}>
                        <strong className="text-brand">KEUNGGULAN KAMI</strong>
                    </ScrollAnimation>
                    <Slider ref={firstRef} {...settingsFirst}>
                        <div>
                            <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                                <div className="header mt-4 text-black">Untuk Partner Bisnis</div>
                                <p className="mt-4">Mengatur pekerjaan, memantau performa, dan melihat laporan hasil akhir, termasuk penjualan.</p>
                            </ScrollAnimation>
                        </div>
                        <div>
                            <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                                <div className="header mt-4 text-black">Untuk Talent</div>
                                <p className="mt-4">Talent melamar, direkrut, menerima pembayaran, dan melihat riwayat tugas.</p>
                            </ScrollAnimation>
                        </div>
                    </Slider>
                    <div className="mt-5 d-flex flex-row gap-3">
                        <div className={`arrow-service ${number === 0 ? "disabled" : ""}`} onClick={() => setNumber(0)}>
                            <FaChevronLeft/>
                        </div>
                        <div className={`arrow-service ${number === 1 ? "disabled" : ""}`} onClick={() => setNumber(1)}>
                            <FaChevronRight/>
                        </div>
                    </div>
                </Col>
                <Col sm={12} md={9} lg={9}>
                    <div className="bg-service">
                        <div className="ps-4 py-5 pb-0">
                            <ScrollAnimation animateIn='fadeInRight' delay={100} animateOnce={true}>
                                {
                                    number === 0 ? (
                                        <div className="fade-in-text">
                                            <Slider {...settings} className="equal-height-slider">
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgMc} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Rekrutmen cepat & seleksi tenaga kerja</strong></div>
                                                            <p className="mt-2 flex-grow-1">Proses rekrutmen yang efisien dengan kualitas terjamin</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgTugas} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Manajemen tugas & tracking performa</strong></div>
                                                            <p className="mt-2 flex-grow-1">Monitoring real-time untuk semua aktivitas tim</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgRekap} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Laporan penjualan & operasional real-time</strong></div>
                                                            <p className="mt-2 flex-grow-1">Dashboard lengkap untuk analisis bisnis</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgFlexible} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Fleksibel dan scalable sesuai kebutuhan bisnis Anda</strong></div>
                                                            <p className="mt-2 flex-grow-1">Sesuai kebutuhan bisnis yang dinamis</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </Slider>
                                        </div>
                                    ) : (
                                        <div className="fade-in-text">
                                            <Slider {...settings} className="equal-height-slider">
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgApp} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Aplikasi kerja terintegrasi</strong></div>
                                                            <p className="mt-2 flex-grow-1">Satu aplikasi untuk semua kebutuhan kerja</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgMoney} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Akses gaji lebih cepat</strong></div>
                                                            <p className="mt-2 flex-grow-1">Sistem pembayaran yang efisien dan transparan</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgShop} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Marketplace kebutuhan harian</strong></div>
                                                            <p className="mt-2 flex-grow-1">Akses mudah untuk berbagai kebutuhan</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="p-1 h-100">
                                                    <Card className="h-100">
                                                        <Card.Body className="d-flex flex-column">
                                                            <img src={imgToken} alt="" width={"25%"}/>
                                                            <div className="mt-3 text-capitalize"><strong>Sistem reward & karir berbasis performa</strong></div>
                                                            <p className="mt-2 flex-grow-1">Pengembangan karir yang jelas dan terukur</p>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </Slider>
                                        </div>
                                    )
                                }
                            </ScrollAnimation>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Service;